<template>
    <header class="header">
        <div class="header__navigation">
            <TheHeaderNavigation />
        </div>
        <div class="header__title">
            <span>{{ headerTitle }}</span>
        </div>
        <div class="header__close-buttons">
            <button
                v-if="isCloseTypeButton"
                class="header__button"
                @click="handleCloseClicked"
            >
                <span class="header__icon header__icon_type_cross" />
            </button>
            <a
                v-if="isCloseTypeWebviewLink"
                class="header__button"
                href="uniwebview://close"
            >
                <span class="header__icon header__icon_type_cross" />
            </a>
        </div>
    </header>
</template>

<script>
import { mapGetters  } from 'vuex';
import { CLOSE_TYPE } from '@/constants/settings';
import { POST_MESSAGES } from '@/constants/postMessages';
import TheHeaderNavigation from '@components/TheHeaderNavigation';

export default {
    name: 'TheHeader',
    components: {
        TheHeaderNavigation,
    },
    data: () => ({
        isForwardAvailable: false,
    }),
    computed: {
        ...mapGetters({
            getFaqCloseButtonType: 'appConfig/getFaqCloseButtonType',
        }),
        isCloseTypeButton() {
            return this.getFaqCloseButtonType === CLOSE_TYPE.BUTTON;
        },
        isCloseTypeWebviewLink() {
            return this.getFaqCloseButtonType === CLOSE_TYPE.WEBVIEW;
        },
        headerTitle() {
            const routeTitle = this.$route.meta.headerTitle;
            if (routeTitle) {
                return this.$t(routeTitle);
            }
            return '';
        },
    },
    methods: {
        handleCloseClicked() {
            window.parent.postMessage(POST_MESSAGES.CLOSE_FORM, '*');
        },
    },
}
</script>